// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected-frame[data-v-6431d976]{border:5px solid #ffafb2;border-radius:20px;padding:2em}.selected-message[data-v-6431d976]{color:#ffafb2}", ""]);
// Exports
module.exports = exports;
